module.exports = __webpack_public_path__ + "img/violenceSurveyManagement.49986fd3.svg";